import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs';
import { ReportsService } from 'src/app/services/reports.service';
import { Location } from '@angular/common'
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { MenuItem } from 'primeng/api';
import saveAs from 'file-saver';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-pond-count-wise-report',
  templateUrl: './pond-count-wise-report.component.html',
  styleUrls: ['./pond-count-wise-report.component.scss']
})
export class PondCountWiseReportComponent implements OnInit {
  @Input() finyear: string;
  
  @ViewChild('dataTable') tableContainer: ElementRef;
  pondUnderProcessReport: MenuItem[];

  public actionType: any;
  // public finYear: any;
  public pondTableData: any = [];
  public loading: boolean = false;
  public userId: any;
  public subscriptions: any = [];
  public subjectSub:any;
  public isAdminLogin: boolean = false;
  public underProcessCount: any;
  public showDrillDownTable: boolean = false;
  public pondBifurcatedData: any;
  public options1: any;

  public tableHeaderName = 'Application Details';
  public pondTableDataWithFilter: any[];

  public tableHeaderColor = '#FFFFFF';
  public actionTypesFromTableData: any =[];
  public pondUnderProcFilterList: any = [];


  constructor(
    private route: ActivatedRoute,
    private reportsService: ReportsService,
    private router: Router,
    private location: Location,
    private loader: AppLoaderService,
    private cryptoJsService: CryptoJsService
  ) { }

  ngOnInit(): void {
    // this.actionType = this.route.snapshot.paramMap.get('actionType');
    // this.finYear = this.route.snapshot.paramMap.get('finYear');

    // console.log(this.finYear, this.actionType);

    // this.finYear = 'All';
    // if(this.finYear == 'All'){
    //   this.finYear = '';
    // }

    this.loadCountBoxesData();

    this.pondUnderProcessReport = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.pondTableDataWithFilter, `Pond/Tank_${this.tableHeaderName}`);
        },
      },
      // {
      //   label: 'Download Pdf',
      //   icon: 'pi pi-fw pi-download',
      //   command: () => {
      //     this.downloadSheetAsPdf(
      //       this.appVerificationModel,
      //       'App_Verification_List'
      //     );
      //   },
      // },
    ];
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'APP ID': d.appid,
          'District': d?.District,
          'Block': d?.Block,
          'Village': d?.Village,
          'Current Level': d.Level_ID,
          'Current Action': d.ActionType,
          'Last Action Date': d.assigneddate,
          'Status': d.Status,
          'Pending Level': d.nextuser,
          'Pending Action': d.NextAction,
          'KYC Status': d.KYCStatus,
          'KYC Date': d.TransDate,
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  loadCountBoxesData() {
    this.loader.start();
    let sub = this.reportsService
      .getPondAggTabsUnProcessedAppsCountNew(this.finyear)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          // console.log(data.length, data)
          if (data?.length > 0) {
            this.underProcessCount = data[0];
            this.loadPONDBifurcatedDataForGraph();
          } else {
            this.underProcessCount = null;
            this.loadPONDBifurcatedDataForGraph();
          }
          // console.log(this.underProcessCount)
        },
        error: (err) => {
          // this.loading = false;
          this.loader.close();
          this.underProcessCount = null;
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });

      this.subscriptions.push(sub);
  }

  printForm(appId) {
    
    if (appId) {
      // let statusCodeEncrypted = this.cryptoJsService.Encrypt(statusCode);
      // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'appliaction-approval', 'print', appId], { queryParams: { statusCode: statusCodeEncrypted } }));
      // window.open(link, '_blank');

      // if(this.subjectSub)
      let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
      let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
      this.userId = JSON.parse(payload)?.sub;
      // console.log(payload, this.userID);
      if(this.userId == 'admin'){
        this.router.navigate(['admin', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } });
        // this.router.navigate(['admin', 'print', this.cryptoJsService.Encrypt(appId)]);
        // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(appId)]));
        // window.open(link, '_blank');
      }else if(this.userId == 'CAO'){
        this.router.navigate(['cao', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } });
        // this.router.navigate(['cao', 'print', this.cryptoJsService.Encrypt(appId)]);
        // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(appId)]));
        // window.open(link, '_blank');
      }else if(this.userId == 'DD-EW'){
        this.router.navigate(['ew-department', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } });
        // this.router.navigate(['ew-department', 'print', this.cryptoJsService.Encrypt(appId)]);
        // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(appId)]));
        // window.open(link, '_blank');
      }else if(this.userId== 'webadmin'){
        this.router.navigate(['webadmin', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } });
        // this.router.navigate(['vendor', 'print', this.cryptoJsService.Encrypt(appId)]);
        // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(appId)]));
        // window.open(link, '_blank');
      }else {
        this.router.navigate(['department', 'print'], { queryParams: { appId:this.cryptoJsService.Encrypt(appId.toString()) } });
        // this.router.navigate(['department', 'print', this.cryptoJsService.Encrypt(appId)]);
        // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(appId)]));
        // window.open(link, '_blank');
      }
    }
    else{
      // this.messageService.add({
      //   summary: 'Error Message',
      //   severity: 'info',
      //   detail: 'Application Id Not Found',
      // });
    }
  }

  ngOnDestroy() {
    this.loader.close();
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  onClickBack(){
    this.location.back();
  }

  onClickCountBox(val){
    this.showDrillDownTable = true;
    this.pondTableData = [];
    this.loadPondDataUnderProcess(val);
    setTimeout( () => this.tableContainer.nativeElement.scrollIntoView({
      block: "center",
      behavior: "smooth"
    }), 400)
  }

  loadPondDataUnderProcess(subActionType) {
    // this.loader.start();
    this.loading = true;
    let sub = this.reportsService
      .getPondAggTabsUnProcessedAppsDrillDownNew(this.finyear, subActionType)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loading = false;
          if (data?.length > 0) {
            this.pondTableData = data;
            this.pondTableDataWithFilter = data;

            this.actionTypesFromTableData, this.pondUnderProcFilterList = this.getUniqueActionType(data);
          }else{
            this.pondTableData = [];
          }
        },
        error: (err) => {
          // this.loading = false;
          this.loading = false;
          this.pondTableData = [];
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });

      this.subscriptions.push(sub);
  }

  loadPONDBifurcatedDataForGraph() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    this.pondBifurcatedData = {
      // labels: [`MI(PDMC) Applications: (${miTotalCount}) `, `Pond/Tank Applications: (${pondTotalCount})`],
      labels: [
        'App Verification',
        'Intimation Stage 1', 
        'Intimation Stage 2', 
        'PV Stage 1', 
        'PV Stage 2', 
        'Subsidy Cal Stage 1',  
        'Subsidy Cal Stage 2',  
        'Subsidy Cal Stage 3', 
        'Lot Stage 1', 
        'Lot Stage 2', 
        'Lot Stage 3', 
        'Subsidy Stage3',
        // 'Rejected'  
      ],
      datasets: [
        {
          data: [
            this.underProcessCount?.AppVerification, 
            this.underProcessCount?.pending_intimation_stage1, 
            this.underProcessCount?.pending_intimation_stage2, 
            this.underProcessCount?.pending_PV_stage1, 
            this.underProcessCount?.pending_PV_stage2, 
            this.underProcessCount?.pending_SubsidyCalc_stage1, 
            this.underProcessCount?.pending_SubsidyCalc_stage2, 
            this.underProcessCount?.pending_SubsidyCalc_stage3, 
            this.underProcessCount?.pending_lot_stage1,
            this.underProcessCount?.pending_lot_stage2,
            this.underProcessCount?.pending_lot_stage3,
            this.underProcessCount?.pending_Subsidy_stage3,
            // this.underProcessCount?.rejected
          ],
          backgroundColor: [
            // documentStyle.getPropertyValue('--green-600'),
            // documentStyle.getPropertyValue('--yellow-600'),
            '#6A1B9A',
            '#4527A0',
            '#6D4C41',
            '#ff0000',
            '#ff9900',
            '#3939ac',
            '#b30000',
            '#408000',
            '#2952a3',
            '#b30059',
            '#52527a',
            '#ac39ac',
            // '#e67300'
            // documentStyle.getPropertyValue('--blue-500')
            // documentStyle.getPropertyValue('--pink-500'),
          ],
          hoverBackgroundColor: [
            // documentStyle.getPropertyValue('--green-500'),
            // documentStyle.getPropertyValue('--yellow-500'),
            '#6A1B9A',
            '#4527A0',
            '#6D4C41',
            '#ff0000',
            '#ff9900',
            '#3939ac',
            '#b30000',
            '#408000',
            '#2952a3',
            '#b30059',
            '#52527a',
            '#ac39ac',
            // '#e67300'
            // documentStyle.getPropertyValue('--pink-400'),
          ],
          label: ''
        },
      ],
    };

    this.options1 = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          color: 'black',
          offset: -7,
          font: {
            weight: 'bold'
          },
        },
        legend: {
          display: false // Hide the legend
        }
      },
      scales: {
        x: {
          ticks: {
            color: 'black',
            font: {
              weight: 'bold'
            },
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false
          }
        },
        y: {
          type: 'logarithmic', // Use logarithmic scale
          ticks: {
            min: 0, // Set the minimum value
            // stepSize: 2,
            // callback: function(value, index, values) {
            //   if (value === 1) return 0; // Set the first label to 0
            //   const labels = ['500', '1000', '5000', '10000', '50000', '100000']; // Custom labels
            //   return labels[index]; // Return custom labels
            // }
            font: {
              weight: 'bold',
              color: 'black'
            },
          },
          // ticks: {
          //   font: {
          //     weight: 700,
          //   },
          //   stepSize: 100,
          //   color: textColorSecondary,
          // },
          grid: {
            display: false,
            // color: this.surfaceBorder,
            // drawBorder: false,
          },
        },
        // y: {
        //   ticks: {
        //     color: textColor,
        //     stepSize: 20,
        //   },
        //   grid: {
        //     color: surfaceBorder,
        //     drawBorder: false
        //   }
        // }

      }
    };
  }

  onPONDChartClick(event){
      if(event?.element?.index == 0){
        this.onClickCountBox('AppVerification');
        this.tableHeaderName = 'App Verification';
        this.tableHeaderColor = '#6A1B9A';
      }else if(event?.element?.index == 1){
        this.onClickCountBox('intimation_stage1');
        this.tableHeaderName = 'Intimation Stage 1';
        this.tableHeaderColor = '#4527A0';
      }else if(event?.element?.index == 2){
        this.onClickCountBox('intimation_stage2');
        this.tableHeaderName = 'Intimation Stage 2';
        this.tableHeaderColor = '#6D4C41';
      }else if(event?.element?.index == 3){
        this.onClickCountBox('PV_stage1');
        this.tableHeaderName = 'PV Stage 1';
        this.tableHeaderColor = '#ff0000';
      }else if(event?.element?.index == 4){
        this.onClickCountBox('PV_stage2');
        this.tableHeaderName = 'PV Stage 2';
        this.tableHeaderColor = '#ff9900';
      }else if(event?.element?.index == 5){
        this.onClickCountBox('subsidyCalc_stage1');
        this.tableHeaderName = 'Subsidy Disbursed Stage 1';
        this.tableHeaderColor = '#3939ac';
      }else if(event?.element?.index == 6){
        this.onClickCountBox('subsidyCalc_stage2');
        this.tableHeaderName = 'Subsidy Disbursed Stage 2';
        this.tableHeaderColor = '#b30000';
      }else if(event?.element?.index == 7){
        this.onClickCountBox('subsidyCalc_stage3');
        this.tableHeaderName = 'Subsidy Disbursed Stage 3';
        this.tableHeaderColor = '#408000';
      }else if(event?.element?.index == 8){
        this.onClickCountBox('lot_stage1');
        this.tableHeaderName = 'Lot Stage 1';
        this.tableHeaderColor = '#2952a3';
      }else if(event?.element?.index == 9){
        this.onClickCountBox('lot_stage2');
        this.tableHeaderName = 'Lot Stage 2';
        this.tableHeaderColor = '#b30059';
      }else if(event?.element?.index == 10){
        this.onClickCountBox('lot_stage3');
        this.tableHeaderName = 'Lot Stage 3';
        this.tableHeaderColor = '#52527a';
      }else if(event?.element?.index == 11){
        this.onClickCountBox('subsidy_stage3');
        this.tableHeaderName = 'Subsidy Stage 3';
        this.tableHeaderColor = '#ac39ac';
      }
    }

  getUniqueActionType(data) {
    const actionLevelSet = new Set(data.map(entry => entry.nextuser));
    const actionLevelObjects = Array.from(actionLevelSet).map(actionLevel => ({ actionLevel }));
    
    return actionLevelObjects;
  }

}
